import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import VueTheMask from 'vue-the-mask';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'

import vco from "v-click-outside"

import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import axios from "axios";
import "@/assets/scss/app.scss";
// import {isCPF, isCNPJ} from 'validation-br'
axios.defaults.baseURL = 'https://us-central1-abcomm-selos.cloudfunctions.net/';

import { initFirebaseBackend } from './helpers/firebase/authUtils';

const firebaseConfig = {
  apiKey: "AIzaSyB8xuhaQ4HbavIu9uMioIyWNaAkA6pnifA",
  authDomain: "abcomm-selos.firebaseapp.com",
  projectId: "abcomm-selos",
  storageBucket: "abcomm-selos.appspot.com",
  messagingSenderId: "481138387361",
  appId: "1:481138387361:web:32e166b9de643b67e2c3e0",
  measurementId: "G-7RJS3NZE86",
};


initFirebaseBackend(firebaseConfig);


// Vue.filter('doc', function (value) {
//   if (isCPF(value)) {
//
//   }else if (isCNPJ(value)) {
//
//   }
//   return value;
// })

// Vue.use(axios);
Vue.config.productionTip = false
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(VueTheMask)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
